import {defineComponent, ref, computed} from "vue";
import * as KlipApi from "@/api/klip-api.proxy";
import {ISelectedOrganisation} from "@/app/admin/components/kl-search-organisation/kl-search-organisation";
import {useKlipApiProxy} from '@/plugins/proxy-client';
import {useForm} from 'vee-validate';
import {useKlModalEventsUtil} from '@/app/shared/helpers/kl-modal-events-util';
import * as yup from 'yup';
import {toTypedSchema} from '@vee-validate/yup';
import {
    klValidationFields,
    ValidationFieldsType
} from '@/app/shared/components/kl-form-fields/kl-field-validation-util';

export interface IZoneToMove {
    zoneId: string;
    sourceKlipOrganisationId: string;
    destinationKlipOrganisationId: string;
    destinationKlipOrganisationName: string;
    reason: string;
    mailTo: string[];
}

export default defineComponent({
    compatConfig: {
        MODE: 3,
    },
    name: 'KlUnaZoneMove',
    emits: ['move'],
    props: {
        zoneId: {
            type: String,
            required: true
        },
        sourceKlipOrganisationId:  {
            type: String,
            required: true
        }
    },
    setup(props, { emit }) {

        const schema = yup.object({
            selectedDestinationOrganisation: yup.object().required().label('Nieuwe organisatie'),
            reason: yup.string().required().label('Reden van verplaatsing'),
            mailTo: yup.string().required().kl_validKlipEmails().label('Mail naar'),
        });

        const proxy = useKlipApiProxy();

        const unaZoneMoveModalEvents = useKlModalEventsUtil('una-zone-move-modal', {
            onClosed() {
                form.resetForm();
            },
        });

        const form = useForm({
            validationSchema: toTypedSchema(schema),
        });
        const fields: ValidationFieldsType<typeof schema> = klValidationFields<typeof schema>(schema);

        const disableSubmit = computed((): boolean => {
            return !form.meta.value.valid || !form.meta.value.dirty || movingZone.value;
        });

        const selectedDestinationOrganisation = fields.selectedDestinationOrganisation.getValue<ISelectedOrganisation>();
        const reason = fields.reason.getValue<string>();
        const mailTo = fields.mailTo.getValue<string>();

        const movingZone = ref<boolean>(false);


        const onCancelMoveUnaZone = () => {
            unaZoneMoveModalEvents.triggerModalToggle();
        };

        const _move = () => {
            emit('move', <IZoneToMove> {
                zoneId: props.zoneId,
                sourceKlipOrganisationId: props.sourceKlipOrganisationId,
                destinationKlipOrganisationId: selectedDestinationOrganisation.value.organisationId,
                destinationKlipOrganisationName: selectedDestinationOrganisation.value.name,
                reason: reason.value,
                mailTo: mailTo.value.split(";").map(m => m.trim())
            });

            unaZoneMoveModalEvents.triggerModalToggle();
        }

        const onOrganisationSelect = (selectedOrganisation: ISelectedOrganisation) => {
            if (!selectedOrganisation || !selectedOrganisation.organisationId) {
                return;
            }

            // get the una emailaddresses
            const request = KlipApi.GetUnaManagerEmailAddressesQuery.fromJS({});
            request.klipOrganisationIds = [props.sourceKlipOrganisationId, selectedOrganisation.organisationId];
            proxy.unaSettings_GetUnaManagerEmailAddresses(request).then((r) => {
                mailTo.value = r.result.join("; ");
            });
        };

        const _onInvalidSubmit = (submittedValues) => {
            console.log('_onInvalidSubmit', submittedValues);
        }

        const onSubmit = form.handleSubmit(_move, _onInvalidSubmit);

        return {
            selectedDestinationOrganisation,
            reason,
            mailTo,

            movingZone,

            onOrganisationSelect,
            onCancelMoveUnaZone,

            onSubmit,
            disableSubmit,

            fields,
        };
    }
});
